import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Creative performance page is viewed',
  name: 'creative_performance_page_viewed',
};

export default META;
